// Template270: Pekín - Día 2 p.3 (Dia2MapaPekin.jsx)
// Cabecera, intro, Templo Lamas + SabiasQue, Templo Confucio (sticker + tip + img), caja metro Lamas, Torre del Tambor y Hutongs (tip + sticker + img), Cómo llegar.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template270 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const title1 = page?.texts?.[2]?.content;
	const body1 = page?.texts?.[3]?.content;
	const text4 = page?.texts?.[4];
	const tipConfucio =
		isSmallScreen && text4?.contentMovil ? text4.contentMovil : text4?.content;
	const title2 = page?.texts?.[5]?.content;
	const body2 = page?.texts?.[6]?.content;
	const metroLamas = page?.texts?.[7]?.content;
	const titleTorre = page?.texts?.[8]?.content;
	const bodyTorre = page?.texts?.[9]?.content;
	const tipTorre = page?.texts?.[10]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const img1 = getImageSrc("img1");
	const stickerConfucio = getImageSrc("sticker-confucio");
	const img2 = getImageSrc("img2");
	const stickerTorre = getImageSrc("sticker-torre");
	const imgTorre = getImageSrc("img-torre");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const comoLlegar = page?.data?.comoLlegar;
	const actualHeaderColor = headerBackgroundColor || "#8c1d18";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
		marginTop: 1,
		marginBottom: 0.5,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 9999,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="text-1" sx={{ padding: "10px 12px", flex: 1, position: "relative" }}>
				{intro && (
					<Box component="p" sx={estiloP}>
						{intro}
					</Box>
				)}

				<Box
					data-block-id="text-2"
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 2,
						marginTop: "10px",
					}}
				>
					{/* Templo de los Lamas */}
					{title1 && (
						<Box
							data-block-id="text-3"
							sx={{
								display: "flex",
								gap: 2.5,
								alignItems: "flex-start",
								position: "relative",
							}}
						>
							{img1 && (
								<Box
									component="img"
									src={img1}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										borderRadius: "12px",
										objectFit: "cover",
									}}
								/>
							)}
							<Box sx={{ width: "60%" }}>
								<Box component="h3" sx={estiloH3}>
									{title1}
								</Box>
								{body1 && (
									<Box component="p" sx={estiloP}>
										{body1}
									</Box>
								)}
								{sabiasQue[0] && (
									<Box sx={{ position: "absolute", top: -10, left: "35%" }}>
										<SabiasQue
											icono={sabiasQue[0].icono}
											texto={sabiasQue[0].texto}
										/>
									</Box>
								)}
							</Box>
						</Box>
					)}

					{/* Templo de Confucio - sticker + tip + img */}
					{title2 && (
						<Box
							data-block-id="text-4"
							sx={{
								display: "flex",
								flexDirection: "column",
								gap: 2,
								position: "relative",
							}}
						>
							{stickerConfucio && (
								<img
									src={stickerConfucio}
									alt=""
									style={{
										width: 95,
										position: "absolute",
										top: 0,
										left: -40,
									}}
								/>
							)}
							{tipConfucio && (
								<Box
									sx={{
										position: "absolute",
										top: -50,
										left: isSmallScreen ? 0 : 20,
										backgroundColor: "#fff8db",
										border: "2px solid #f5c400",
										borderRadius: "16px 16px 16px 0px",
										padding: "10px 12px",
										fontSize: 11,
										color: "#444",
										boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
										maxWidth: isSmallScreen ? 100 : 160,
									}}
								>
									{tipConfucio}
								</Box>
							)}
							<Box sx={{ display: "flex", gap: 2.5, alignItems: "flex-start" }}>
								{img2 && (
									<Box
										component="img"
										src={img2}
										alt=""
										sx={{
											width: "40%",
											height: 110,
											borderRadius: "12px",
											objectFit: "cover",
										}}
									/>
								)}
								<Box sx={{ width: "60%" }}>
									<Box component="h3" sx={estiloH3}>
										{title2}
									</Box>
									{body2 && (
										<Box component="p" sx={estiloP}>
											{body2}
										</Box>
									)}
								</Box>
							</Box>
						</Box>
					)}

					{/* Caja metro Lamas */}
					{metroLamas && (
						<Box
							data-block-id="text-5"
							sx={{
								backgroundColor: "#fde1e0",
								border: "3px solid",
								borderColor: actualHeaderColor,
								borderRadius: "12px",
								padding: "8px 14px",
								fontSize: 12,
								color: "#444",
								textAlign: "center",
								marginTop: isSmallScreen ? 0 : "-10px",
							}}
						>
							{metroLamas}
						</Box>
					)}

					{/* Torre del Tambor y Hutongs */}
					{titleTorre && (
						<Box data-block-id="text-6" sx={{ position: "relative", marginTop: "-10px" }}>
							<Box
								sx={{
									padding: "10px 12px",
									paddingTop: 0,
									position: "relative",
								}}
							>
								<Box component="h3" sx={estiloH3}>
									{titleTorre}
								</Box>
								{bodyTorre && (
									<Box component="p" sx={estiloP}>
										{bodyTorre}
									</Box>
								)}
							</Box>
							{tipTorre && (
								<Box
									sx={{
										position: "absolute",
										bottom: 30,
										left: 80,
										backgroundColor: "#fff8db",
										border: "2px solid #f5c400",
										borderRadius: "16px 16px 16px 0px",
										padding: "10px 12px",
										fontSize: 11,
										color: "#444",
										boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
										maxWidth: isSmallScreen ? 260 : 320,
										zIndex: 2,
									}}
								>
									{tipTorre}
								</Box>
							)}
							{stickerTorre && (
								<img
									src={stickerTorre}
									alt=""
									style={{
										width: 95,
										position: "absolute",
										bottom: 0,
										left: 0,
									}}
								/>
							)}
							{imgTorre && (
								<Box
									component="img"
									src={imgTorre}
									alt=""
									sx={{
										width: "100%",
										height: isSmallScreen ? 120 : 100,
										objectFit: "cover",
										marginBottom: 0.75,
									}}
								/>
							)}
						</Box>
					)}

					{/* Cómo llegar */}
					{comoLlegar && (
						<Box
							data-block-id="text-7"
							sx={{
								backgroundColor: "#fde1e0",
								border: "3px solid",
								borderColor: actualHeaderColor,
								borderRadius: "12px",
								padding: "8px 12px",
								fontSize: 13,
								color: "#333",
								marginBottom: isSmallScreen ? 1.5 : 0,
								marginTop: isSmallScreen ? 0 : "-10px",
							}}
						>
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: 1,
									fontSize: 13,
									fontWeight: 700,
									color: actualHeaderColor,
									textTransform: "uppercase",
								}}
							>
								Cómo llegar
							</Box>
							<Box
								component="ul"
								sx={{ paddingLeft: 2.5, margin: 0, lineHeight: 1.6 }}
								dangerouslySetInnerHTML={{ __html: comoLlegar }}
							/>
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template270.thumbnail = "/images/template-1.png";
export default Template270;
